module.exports = __webpack_public_path__ + "media/toolkits/blog-img1-a9cf2b8c.jpg";